import axios from 'axios'

const baseDomain = "https://httpbin.org"    // /getで成功
const baseURL = `${baseDomain}`
export default axios.create({
    baseURL: baseURL
})